<script>
export default {
  inheritAttrs: false,
  props: {
    href: {
      type: String,
      default: '',
    },
    allowInsecure: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    exactActiveClass: {
      type: String,
      default: 'active',
    },
  },
  computed: {
    routerLinkTo({ name, params }) {
      return {
        name,
        params,
        ...(this.to || {}),
      }
    },
  },
  created() {
    this.validateProps()
  },
  methods: {
    subIsActive(input, to) {
      // const paths = Array.isArray(input) ? input : [input]
      // console.log('paths', paths, to)
      // console.log(this.$route)
      // return paths.some((path) => {
      //   return this.$route.path.indexOf(path) === 0
      // })
      // if (this.$route.name === to.name) {
      //   return true
      // }
      if (Object.keys(this.$route.params).length) {
        const isSame = Object.keys(this.$route.params).some((key) => {
          return this.$route.params[key] === to.params[key]
        })

        return (
          this.$route.name && this.$route.name.indexOf(to.name) === 0 && isSame
        )
      }

      if (to.children && to.children.length) {
        return to.children.includes(this.$route.name)
      }

      return this.$route.name && this.$route.name.indexOf(to.name) === 0
    },
    // Perform more complex prop validations than is possible
    // inside individual validator functions for each prop.
    validateProps() {
      if (process.env.NODE_ENV === 'production') return

      if (this.href) {
        // Check for non-external URL in href.
        if (!/^\w+:/.test(this.href)) {
          return console.warn(
            `Invalid <BaseLink> href: ${this.href}.\nIf you're trying to link to a local URL, provide at least a name or to`
          )
        }
        // Check for insecure URL in href.
        if (!this.allowInsecure && !/^(https|mailto|tel):/.test(this.href)) {
          return console.warn(
            `Insecure <BaseLink> href: ${this.href}.\nWhen linking to external sites, always prefer https URLs. If this site does not offer SSL, explicitly add the allow-insecure attribute on <BaseLink>.`
          )
        }
      } else {
        // Check for insufficient props.
        if (!this.name && !this.to) {
          return console.warn(
            `Invalid <BaseLink> props:\n\n${JSON.stringify(
              this.$props,
              null,
              2
            )}\n\nEither a \`name\` or \`to\` is required for internal links, or an \`href\` for external links.`
          )
        }
      }
    },
  },
}
</script>

<template>
  <a v-if="href" :href="href" target="_blank" v-bind="$attrs">
    <slot />
  </a>
  <RouterLink
    v-else
    :to="routerLinkTo"
    v-bind="$attrs"
    :class="{ [exactActiveClass]: subIsActive('/carteira', routerLinkTo) }"
  >
    <slot />
  </RouterLink>
</template>
